export var UPDATE_ATTRIBUTE_TYPE = 'update_attribute_type';
export var UPDATE_PRODUCT = 'update_product';